import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SOURCE_URL } from '../../../config';
import 'swiper/css/bundle';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import language from '../../../utils/LanguageSettings';
import translations from '../../../text/get-started-translations.json';
import { getLocalizedData } from '../../functions/getLocalizedData';



const FilteredArticles: React.FC<{ filteredArticles: any[]; articlesPerPage: number; type: string }> = ({ filteredArticles, articlesPerPage, type }) => {
  const [currentPage, setCurrentPage] = useState(1);
  let totalPages = 1;
  const location = useLocation();
  const { pathname, hash } = location;
  const pageTranslations = translations[language];

  useEffect(() => {
    setCurrentPage(1);
  }, [pathname, hash, type]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getPaginatedArticles = () => {
    if (!filteredArticles) return [];
    totalPages = filteredArticles ? Math.ceil(filteredArticles.length / articlesPerPage) : 0;
    if (currentPage === 1) {
      return filteredArticles.slice(0, articlesPerPage);
    }
    const startIndex = (currentPage - 1) * articlesPerPage;
    return filteredArticles.slice(startIndex, startIndex + articlesPerPage);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    if (language === 'en') {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      return `${day} ${monthNames[monthIndex]} ${year}`;
    }
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('zh-HK', options);
  };

  const isRecentArticle = (dateString: string) => {
    const updateDate = new Date(dateString);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - updateDate.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    return dayDifference <= 10;
  };

  return (
    <div className="container">
      <div className="articles-wrapper">
        <div className="row">
          {getPaginatedArticles().map((article: any) => (
            <div key={article.id} className="card" data-type={article.attributes.Categories?.Categories?.join(' ')}>
              <Link to={`/blog/${article.attributes.slug}`}>
                {article.attributes.FeaturedImage?.data?.attributes?.formats?.small?.url && (
                  <img className="card-img-top" src={SOURCE_URL + article.attributes.FeaturedImage.data.attributes.formats.small.url} alt="" />
                )}
              </Link>
              <div className="card-header">
                <Link to={`/blog/${article.attributes.slug}`}>
                  <h3>{article.attributes.Title}</h3>
                </Link>
              </div>
              <div className="card-body">
                <Link to={`/blog/${article.attributes.slug}`}>
                  <small>{formatDate(article.attributes.updatedAt)}</small>
                  <p>{article.attributes.LeadIn}</p>
                </Link>
                <div className="tags-wrapper">
                  {isRecentArticle(article.attributes.updatedAt) && (
                    <Link to={`/blog/filter/最新文章_Latest Update`}>{pageTranslations.LatestUpdate}</Link>
                  )}
                  {article.attributes.Categories?.Categories?.map((category: string) => (
                    <Link key={category} to={`/blog/filter/${category}`}>{getLocalizedData(category, language)}</Link>
                  ))}
                </div>
              </div>
            </div>

          ))}
        </div>
      </div>

      {/* pagination */}
      <nav aria-label="Page navigation">
        <ul className="pagination">
          {currentPage > 1 && (
            <li className="page-item first">
              <Link className="page-link" to={{pathname: pathname, hash: hash}} onClick={() => handlePageChange(currentPage - 1)}>{pageTranslations.Previous}</Link>
            </li>
          )}
          {Array.from({ length: totalPages }, (_, index) => (
            <React.Fragment key={index + 1}>
              {totalPages > 1 && (
                <li className="page-item">
                  <Link className={`page-link ${currentPage === index + 1 ? 'active' : ''}`} to={{pathname: pathname, hash: hash}} onClick={() => handlePageChange(index + 1)}>{index + 1}</Link>
                </li>
              )}
            </React.Fragment>
          ))}
          {currentPage < totalPages && (
            <li className="page-item last">
              <Link className="page-link" to={{pathname: pathname, hash: hash}} onClick={() => handlePageChange(currentPage + 1)}>{pageTranslations.Next}</Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default FilteredArticles;